import React, { ReactElement } from 'react';
import Box, { TBoxProps } from '../Box/Box';
import DEFAULT_OFFSET from './constants/DEFAULT_OFFSET';
import PLACEMENT from './constants/PLACEMENT';
import usePopOver, { TUsePopOverProps } from './hooks/usePopOver';
import { TertiaryIconButton } from '../IconButton';

type TPopOverWrapperProps = {
  /** Sets the PopOverTrigger container className. */
  className?: string;
  as?: TBoxProps['as'];
} & TUsePopOverProps;

const PopOverWrapper = ({
  as = 'div',
  className,
  children,
  placement = PLACEMENT.RIGHT,
  skidding = DEFAULT_OFFSET.SKIDDING,
  distance = DEFAULT_OFFSET.DISTANCE,
  openOnClick = true,
  openOnHover = false,
  ...rest
}: TPopOverWrapperProps): ReactElement => {
  const {
    attributes,
    isOpen,
    setPopperElement,
    setReferenceElement,
    styles,
    Content,
    Trigger,
    contentProps: { onClose },
  } = usePopOver({
    children,
    placement,
    distance,
    skidding,
    openOnClick,
    openOnHover,
    ...rest,
  });
  const position = attributes?.popper?.['data-popper-placement'] || placement;

  return (
    <>
      <Box as={as} name="PopOverTrigger" className={className} ref={setReferenceElement}>
        {Trigger}
      </Box>

      {isOpen && (
        <Box
          as="div"
          name="PopOverContent"
          modifiers={position}
          ref={setPopperElement}
          style={styles.popper}
          onMouseDown={(e) => {
            e.preventDefault();
          }}
          {...attributes.popper}
        >
          <Box as="div" parent="PopOverContent" name="body">
            {Content}
          </Box>
          {!openOnHover && (
            <Box as="div" parent="PopOverContent" name="close">
              <TertiaryIconButton color="text-link-default" onClick={onClose} name="close" ariaLabel="Close" />
            </Box>
          )}
        </Box>
      )}
    </>
  );
};

export default PopOverWrapper;
